import React from 'react';

const Loader = () =>
{
  return (
    <i className="utv-loader"></i>
  );
}

export default Loader;
